export default __webpack_public_path__ + "static/media/about-bg.6c18e0d1.svg";